import { RootState } from '../store';

export const selectStreamProfiles = (state: RootState) => state.streamProfile.profiles;
export const selectStreamProfilesLoaded = (state: RootState) => state.streamProfile.loaded;
export const selectStreamProfileIncidents = (state: RootState) => state.streamProfile.incidents;
